import DynamicFormPayloadResourceModel from '../../generated/types/model/resource/DynamicFormPayloadResourceModel';

export default class DynamicFormPayloadResourceViewModel extends DynamicFormPayloadResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
